import { render, staticRenderFns } from "./DefaultOptionJsonDataField.vue?vue&type=template&id=17393a35"
import script from "./DefaultOptionJsonDataField.vue?vue&type=script&lang=ts"
export * from "./DefaultOptionJsonDataField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports